import { api, LightningElement, wire } from "lwc";

import { LabelsAdapter, LabelsAdapterValue } from "common/labelsAdapter";

import type { InlineToastVariant } from "tds/inlineToast";
import * as locales from "./locales";

// Mapping from template names to their appropriate toast variants
const TEMPLATE_VARIANT_MAP: Record<string, InlineToastVariant> = {
  badgeCompletionServiceDisruption: "error",
  // Add more template mappings here as needed
};

export default class InlineToastMessage extends LightningElement {
  @api templateName: string = undefined!;

  @wire(LabelsAdapter, { locales })
  private labels: LabelsAdapterValue = null!;

  private get variant(): InlineToastVariant {
    if (!this.templateName) {
      return "info"; // Default fallback
    }
    return TEMPLATE_VARIANT_MAP[this.templateName] || "info";
  }

  private get heading() {
    if (!this.templateName || !this.labels) {
      return undefined;
    }
    return this.labels[`${this.templateName}.heading`];
  }

  private get message() {
    if (!this.templateName || !this.labels) {
      return undefined;
    }
    return this.labels[`${this.templateName}.message`];
  }
}
